import BrandSnap from './Brand_Snap.json';
import BSA from './BSA.json';
import CelebritySnap from './Celebrity_Snap.json';
import FragranceProductFocus from './Fragrance_Product_Focus.json';
import FragranceTrackingCampaignProductAnalysis from './Fragrance_tracking_(campaign_product_analysis).json';
import HaircareProductFocus from './/Haircare_Product_Focus.json';
import HaircareTrackingCampaignProductAnalysis from './Haircare_tracking_(campaign_product_analysis).json';
import MakeupProductFocus from './Makeup_Product_Focus.json';
import MakeupTrackingCampaignProductAnalysis from './Makeup_tracking_(campaign_product_analysis).json';
import SkincareProductFocus from './Skincare_Product_Focus.json';
import SkincareTrackingCampaignProductAnalysis from './Skincare_tracking_(campaign_product_analysis).json';
import TrackingOnlyCampaignAnalysis from './Tracking_(only_campaign_analysis).json';

export const data = {
  "Brand Snap": [
    { "id": 1, "label": "Brand Snap", "data": BrandSnap, "fileName": "Brand_Snap.json" }
  ],
  "BSA (Brand Success Analysis)": [
    { "id": 1, "label": "BSA (Brand Success Analysis)", "data": BSA, "fileName": "BSA.json" }
  ],
  "Celebrity Snap": [
    { "id": 1, "label": "Celebrity Snap", "data": CelebritySnap, "fileName": "Celebrity_Snap.json" }
  ],
  "Product Focus": [
    { "id": 1, "label": "Fragrance Product Focus", "data": FragranceProductFocus, "fileName": "Fragrance_Product_Focus.json" },
    { "id": 2, "label": "Haircare Product Focus", "data": HaircareProductFocus, "fileName": "Haircare_Product_Focus.json" },
    { "id": 3, "label": "Makeup Product Focus", "data": MakeupProductFocus, "fileName": "Makeup_Product_Focus.json" },
    { "id": 4, "label": "Skincare Product Focus", "data": SkincareProductFocus, "fileName": "Skincare_Product_Focus.json" },
  ],
  "Tracking": [
    { "id": 1, "label": "Fragrance tracking (campaign + product analysis)", "data": FragranceTrackingCampaignProductAnalysis, "fileName": "Fragrance_tracking_(campaign_product_analysis).json" },
    { "id": 2, "label": "Fragrance tracking (Product only)", "data": FragranceProductFocus, "fileName": "Fragrance_Product_Focus.json" },
    { "id": 3, "label": "Haircare tracking (campaign + product analysis)", "data": HaircareTrackingCampaignProductAnalysis, "fileName": "Haircare_tracking_(campaign_product_analysis).json" },
    { "id": 4, "label": "Haircare tracking (Product only)", "data": HaircareProductFocus, "fileName": "Haircare_Product_Focus.json" },
    { "id": 5, "label": "Makeup tracking (campaign + product analysis)", "data": MakeupTrackingCampaignProductAnalysis, "fileName": "Makeup_tracking_(campaign_product_analysis).json" },
    { "id": 6, "label": "Makeup tracking (Product only)", "data": MakeupProductFocus, "fileName": "Makeup_Product_Focus.json" },
    { "id": 7, "label": "Skincare tracking (campaign + product analysis)", "data": SkincareTrackingCampaignProductAnalysis, "fileName": "Skincare_tracking_(campaign_product_analysis).json" },
    { "id": 8, "label": "Skincare tracking (Product only)", "data": SkincareProductFocus, "fileName": "Skincare_Product_Focus.json" },
    { "id": 9, "label": "Tracking (only campaign analysis)", "data": TrackingOnlyCampaignAnalysis, "fileName": "Tracking_(only_campaign_analysis).json" },
  ],
};